/**
 * Global spacing constants for consistent layout across pages
 */

export const SECTION_SPACING = '4rem'; // 64px - Spacing between major sections
export const SUBSECTION_SPACING = '4rem'; // 64px - Spacing before subsection titles
export const ELEMENT_SPACING = '1rem'; // 16px - Spacing between elements

const spacingConstants = {
  SECTION_SPACING,
  SUBSECTION_SPACING,
  ELEMENT_SPACING
};

export default spacingConstants;
